import { BiquadFilter, ToneAudioNode } from "tone";
import { limitToNyquist } from "../utils/parameters";

// DJ Filter.
// Allows to control HPF and LPF with the same value
const MAX_FREQ = 13745; // the maximum is half the sample rate
const MIN_FREQ = 20;
export class DJFilter extends ToneAudioNode {

    constructor() {
        super();
        this.lpf = new BiquadFilter({ frequency: limitToNyquist(MAX_FREQ), type: "lowpass", Q: 10 });
        this.hpf = new BiquadFilter({ frequency: 0, type: "highpass", Q: 0 });
        this.lpf.connect(this.hpf);
        this.input = this.lpf;
        this.output = this.hpf;
    }

    dispose() {
        super.dispose();
        this.lpf.dispose();
        this.hpf.dispose();
    }

    #setValue(newValue) {
        let lpfFreq = MAX_FREQ;
        let hpfFreq = MIN_FREQ;
        if (newValue < 0.5) { // LPF
            const norm = newValue * 2;
            lpfFreq = Math.pow(10, norm*(Math.log10(MAX_FREQ)-Math.log10(MIN_FREQ))+Math.log10(MIN_FREQ));
        } else if (newValue > 0.5) { // HPF
            const norm = newValue * 2 - 1;
            hpfFreq = Math.pow(10, norm*(Math.log10(MAX_FREQ)-Math.log10(MIN_FREQ))+Math.log10(MIN_FREQ));
        }
        this.lpf.set({ frequency: limitToNyquist(lpfFreq) });
        this.hpf.set({ frequency: limitToNyquist(hpfFreq) });
    }

    set(params) {
        const {value, frequency, type, ...cascadingParams} = params;
        if (frequency != null) console.error("You don't set frequency direcly to DJFilter; instead, you give it a value between 0 and 1");
        if (type != null) console.error("The DJ Filter's internal filter types are fixed to lowpass and highpass");
        if (value != null) this.#setValue(value);
        this.lpf.set(cascadingParams);
        this.hpf.set(cascadingParams);
    }

}
